import { render, staticRenderFns } from "./NormTreatySurplus.vue?vue&type=template&id=c5c28d6a&"
import script from "./NormTreatySurplus.vue?vue&type=script&lang=js&"
export * from "./NormTreatySurplus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports